import { render, staticRenderFns } from "./uploadexcel.vue?vue&type=template&id=3c42671a"
import script from "./uploadexcel.vue?vue&type=script&lang=js"
export * from "./uploadexcel.vue?vue&type=script&lang=js"
import style0 from "./uploadexcel.vue?vue&type=style&index=0&id=3c42671a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports